import React from 'react';
import { Box, Typography, Button, Grid, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import profile from '../Assets/bhuvneswar_profile-removebg-preview.png';

// Typewriter Effect Component
const TypewriterText = ({ text, speed = 100 }) => {
  const [displayedText, setDisplayedText] = React.useState('');
  
  React.useEffect(() => {
    if (!text || text.length === 0) return; // If the text is empty or undefined, don't run the effect

    let index = 0;
    const interval = setInterval(() => {
      setDisplayedText((prev) => prev + text[index]);
      index += 1;
      if (index === text.length-1) {
        clearInterval(interval); // Stop the interval when all text is typed
      }
    }, speed);

    return () => clearInterval(interval); // Clean up interval on unmount
  }, [text, speed]);

  return displayedText;
};

const Home = () => {
  const theme = useTheme();

  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeInOut',
        staggerChildren: 0.2, // Delay for child animations
      },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' },
    },
  };

  const introText = "Hii, I'm Bhuvneswar, a passionate backend, Flutter, and MERN developer. Explore my projects, skills, and certifications to learn more about me!";

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'background.default',
        padding: 2,
      }}
    >
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        style={{ width: '100%' }}
      >
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          {/* Profile Image */}
          <Grid item xs={12} md={5}>
            <motion.div variants={childVariants}>
              <Box
                component={motion.img}
                src={profile}
                alt="Profile"
                sx={{
                  width: { xs: '200px', sm: '250px', md: '60%' },
                  height: 'auto',
                  borderRadius: '50%',
                  display: 'block',
                  margin: '0 auto',
                  backgroundColor: theme.palette.mode === 'light' ? 'lightblue' : 'white',
                  padding: 1,
                  boxShadow:
                    theme.palette.mode === 'light'
                      ? '0 4px 20px rgba(0,0,0,0.2)'
                      : '0 4px 20px rgba(255,255,255,0.2)',
                }}
                whileHover={{
                  scale: 1.1,
                  rotate: 3,
                  boxShadow:
                    theme.palette.mode === 'light'
                      ? '0 6px 30px rgba(0,0,0,0.3)'
                      : '0 6px 30px rgba(255,255,255,0.3)',
                }}
              />
            </motion.div>
          </Grid>

          {/* Content Section */}
          <Grid item xs={12} md={7}>
            <motion.div variants={childVariants}>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 'bold',
                  marginBottom: 2,
                  textAlign: { xs: 'center', md: 'left' },
                  fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
                }}
              >
                Welcome to My Portfolio
              </Typography>
            </motion.div>
            <motion.div variants={childVariants}>
              <Typography
                variant="h5"
                sx={{
                  marginBottom: 4,
                  color: 'text.secondary',
                  textAlign: { xs: 'center', md: 'left' },
                  fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
                }}
              >
                <TypewriterText text={introText} />
              </Typography>
            </motion.div>
            <Grid container spacing={2} justifyContent={{ xs: 'center', md: 'flex-start' }}>
              <Grid item>
                <motion.div variants={childVariants}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    href="#projects"
                    sx={{ paddingX: 3, transition: 'transform 0.3s ease' }}
                    whileHover={{ scale: 1.1 }}
                  >
                    View Projects
                  </Button>
                </motion.div>
              </Grid>
              <Grid item>
                <motion.div variants={childVariants}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    size="large"
                    href="#contact"
                    sx={{ paddingX: 3, transition: 'transform 0.3s ease' }}
                    whileHover={{ scale: 1.1 }}
                  >
                    Contact Me
                  </Button>
                </motion.div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </motion.div>
    </Box>
  );
};

export default Home;
